import React, { useRef, useEffect, useState, useCallback } from 'react'

export const VideoPlayer = ({ videoUrl }: { videoUrl: string }): JSX.Element => {
  const [_player, setPlayer] = useState<YT.Player | null>(null)
  const idRef = useRef(`betterplace-video-player-${Math.random().toString(36).substr(2, 9)}`)

  const onYoutubeReady = useCallback(() => {
    const p = new YT.Player(idRef.current, {
      events: {},
    })
    setPlayer(p)
  }, [])

  useEffect(() => {
    window.onYouTubeIframeAPIReady = onYoutubeReady
    const script = document.createElement('script')
    script.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode?.insertBefore(script, firstScriptTag)
  }, [onYoutubeReady])

  return <iframe allowFullScreen width="508" height="286" id={idRef.current} src={videoUrl} frameBorder="0" />
}
